import { Box, Button, Menu, MenuItem } from '@material-ui/core';

import { ReactComponent as AzerbaijaniFlagIcon } from 'assets/icons/flags/az.svg';
import { ReactComponent as EnglishFlagIcon } from 'assets/icons/flags/en.svg';
import { ReactComponent as RussianFlagIcon } from 'assets/icons/flags/ru.svg';

import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { useSettings } from 'context/SettingsContext';
import { useStyle } from './language-menu.style';

export const LanguageMenu: React.FC = () => {
    const classes = useStyle();
    const { i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const { language = 'az', setLanguage } = useSettings();

    const languages = {
        az: { name: 'Azərbaycanca', icon: AzerbaijaniFlagIcon, shortName: 'AZ' },
        en: { name: 'English', icon: EnglishFlagIcon, shortName: 'EN' },
        ru: { name: 'Русский', icon: RussianFlagIcon, shortName: 'РУ' },
    };
    const LanguageIcon = languages[language].icon;
    const handleClose = (): void => setAnchorEl(null);

    return (
        <Box className={classes.root}>
            <div className={classes.languageWrapper}>
                <Button className={classes.language} onClick={(e) => setAnchorEl(e.currentTarget)}>
                    <LanguageIcon width={28} height={28} style={{ marginRight: 6 }} />
                    {languages[language].shortName}
                </Button>
            </div>
            <Menu open={!!anchorEl} anchorEl={anchorEl} onClose={handleClose}>
                {Object.keys(languages).map((key) => (
                    <MenuItem
                        key={key}
                        value="en"
                        selected={language === key}
                        onClick={() => {
                            i18n.changeLanguage(key);
                            setLanguage(key);
                            handleClose();
                        }}
                    >
                        {languages[key].name}
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};
